import { z } from 'zod';
import LangEnum from '../../lang/LangEnum';
import { TranslateType } from '../translation/translationContext.types';

const TITLE_MAX_LENGTH = 100;
const WEBSITE_MAX_LENGTH = 100;
const ABOUT_ME_MAX_LENGTH = 450;

export const buildBrandAboutSectionSchema = (translate: TranslateType) =>
  z.object({
    commercialName: z.string().trim().min(1, translate(LangEnum.GLOBAL_REQUIRED)),
    title: z
      .string()
      .trim()
      .max(
        TITLE_MAX_LENGTH,
        translate(LangEnum.GLOBAL_CHARACTERS_MAX_LIMIT, { num: TITLE_MAX_LENGTH }),
      ),
    website: z
      .string()
      .trim()
      .max(
        WEBSITE_MAX_LENGTH,
        translate(LangEnum.GLOBAL_CHARACTERS_MAX_LIMIT, { num: WEBSITE_MAX_LENGTH }),
      ),
    aboutMe: z
      .string()
      .trim()
      .max(
        ABOUT_ME_MAX_LENGTH,
        translate(LangEnum.GLOBAL_CHARACTERS_MAX_LIMIT, { num: ABOUT_ME_MAX_LENGTH }),
      ),
    wholesaleMediumPrice: z.string(),
    logoUrl: z.string().nullable(),
    bannerUrl: z.string().nullable(),
    instagramUrl: z.string().trim(),
    facebookUrl: z.string().trim(),
    twitterUrl: z.string().trim(),
    pinterestUrl: z.string().trim(),
    youtubeUrl: z.string().trim(),
    segmentIds: z.array(z.string()),
  });

export type BrandAboutSectionFormValues = z.infer<ReturnType<typeof buildBrandAboutSectionSchema>>;
